import { getCsrfToken } from './csrf';
const EVENT_READY = 'signlift:signature:ready';
const EVENT_SUCCESS = 'signlift:signature:success';
const EVENT_ERROR = 'signlift:signature:error';

const KNOWN_EVENTS = new Set([
  EVENT_READY,
  EVENT_SUCCESS,
  EVENT_ERROR,
]);

function originOf(signingUrl) {
  try {
    return new URL(signingUrl).origin;
  } catch {
    return null;
  }
}

export function embedSignature(container, signingUrl) {
  if (!container || !signingUrl) return null;

  const iframe = document.createElement('iframe');
  iframe.src = signingUrl;
  iframe.style.width = '100%';
  iframe.style.height = '600px';
  iframe.style.border = '0';
  iframe.allow = 'clipboard-write';
  container.replaceChildren(iframe);
  return iframe;
}

// Signlift posts with targetOrigin '*', so the filtering is ours alone.
// No origin means no listener at all: guarding inside the handler
// accepted a forged success event from any window.
export function onSignliftEvent(callback, signingUrl, iframe = null) {
  const expectedOrigin = originOf(signingUrl);
  if (!expectedOrigin) return () => {};

  const handler = (event) => {
    if (event.origin !== expectedOrigin) return;
    if (iframe && event.source !== iframe.contentWindow) return;

    const type = event.data?.type;
    if (!KNOWN_EVENTS.has(type)) return;

    callback({type});
  };

  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
}

// The server reconfirms against the API; nothing from the payload is trusted.
export function finalizeSignature(url) {
  if (!url) return Promise.resolve();

  return fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  }).catch((error) => {
    console.warn('[Signlift] finalize request failed', error);
  });
}

export const SIGNLIFT_EVENTS = {
  READY: EVENT_READY,
  SUCCESS: EVENT_SUCCESS,
  ERROR: EVENT_ERROR,
};
